export class FriendStatus {
  private constructor(public readonly value: string) {}

  static readonly none = new FriendStatus("None");
  static readonly following = new FriendStatus("Following");
  static readonly friend = new FriendStatus("Friend");
  static readonly follower = new FriendStatus("Follower");
  static readonly follow = new FriendStatus("Follow");
  static readonly followBack = new FriendStatus("Follow Back");

  static customStatus(friendStatus: string): FriendStatus {
    return new FriendStatus(friendStatus);
  }

  static getType(value: string): FriendStatus {
    switch (value) {
      case "None":
        return FriendStatus.none;
      case "Following":
        return FriendStatus.following;
      case "Friend":
        return FriendStatus.friend;
      case "Follower":
        return FriendStatus.follower;
      case "Follow":
        return FriendStatus.follow;
      case "Follow Back":
        return FriendStatus.followBack;
      default:
        return FriendStatus.none;
    }
  }
}

